<script setup>
  import { ref, defineAsyncComponent } from 'vue'

  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from '@/components/DataContainer.vue';

  const MarineForecastListing = defineAsyncComponent(() => import('@/components/MarineForecastListing.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
    required: true
    }
  });

  const content = ref(null);
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="marine-forecast"
      title="Marine Forecast"
      containerTypeId="Current Conditions"
      minHeight="120px"
      :metaActions="false"
    >
      <template #content="{ isVisible }">
        <DataContainer style="width: 100%; height: 100%;">
          <MarineForecastListing
             v-if="isVisible"
            v-model:content="content"
          />
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>